import React, { useEffect, useState } from "react";
import moment from 'moment'
import { ThemeProps } from "../../genericComponents/globalStyles";
import { numberFormat } from '../../../helpers/utils'
import styled from "styled-components";

export default function PaymentHistory({ paymentHistory }){

  const getRenderedPaymentStatus = (paymentStatus) => {
    switch (paymentStatus) {
        case 'error':
        return (<ErrorPayment title={"Error on your payment, please retry"} />)
        case 'pending':
        return (<PendingPayment title={"Your payment in being processed"} />)
        case 'complete':
        return (<CompletedPayment title={"Your payment was completed successfully"} />)
        default:
        return (<PendingPayment />)
    }
  }

  return (
    <Container>
      <PaymentHeader>
        <Title>Payments</Title>
      </PaymentHeader>
      <Content>
        {(paymentHistory?.payments?.length > 0) ?
          <Table>
            <HeaderRow>
              <ItemHeader>Status</ItemHeader>
              <ItemHeader>Membership</ItemHeader>
              <ItemHeader>Amount</ItemHeader>
              <ItemHeader>Start Date</ItemHeader>
              <ItemHeader>Due Date</ItemHeader>
              <ItemHeader>Creation</ItemHeader>
            </HeaderRow>
            <Body>
            {paymentHistory?.payments?.map((item, index) =>
              <ContainerRow key={index}>
                {getRenderedPaymentStatus(item.payment_status)}
                <Item><ItemContent>{item.membership.name}</ItemContent></Item>
                <Item><ItemContent>${numberFormat(item.gross_amount)}</ItemContent></Item>
                <Item><ItemContent>{moment(item.start_date).format('MMM YYYY')}</ItemContent></Item>
                <Item><ItemContent>{(item.membership.type === 'LifeTime') ? 'none' : moment(item.end_date).format('MMM YYYY')}</ItemContent></Item>
                <Item><ItemContent>{moment(item.created_at).format('MM-DD-YYYY')}</ItemContent></Item>
              </ContainerRow>
            )}
            </Body>
          </Table>
        : 
          <Message>You have not made any payment yet!</Message>
        }
      </Content>

    </Container>
  )
}



const Message = styled.div`
  text-align:center;
  width: 100%;
  flex-basis: 100%;
  height: 48px;
  border-radius: 6px;
  color: ${ThemeProps.color.darkBlue};
  background-color: ${ThemeProps.color.gabaYellow};
  outline: none;
  font-size: 20px;
  font-weight: 500;
  padding: 9px 14px;
`;
const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content:center;
  align-items: center;
`;
const Table = styled.div`
  display: table;
  width:100%;
`;
const Title = styled.div`
  font-size: 2.8em;
  font-weight: bold;
  margin-top: 16px;
  color: ${ThemeProps.color.darkBlue};
`;
const Content = styled.div`
  display: flex;
  width:80%;
  min-width: 360px;
  overflow-x: scroll;
`;
const PaymentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 62px;
  width: 100%;
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
  }
`;
const Body = styled.div`
  display: table-row-group;
`;
const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-evenly;
  align-items:flex-start;
  padding:3px 0;
`;
const ContainerRow = styled(Row)`
  background: ${ThemeProps.color.softYellow};
  display: table-row;
`;
const HeaderRow = styled(Row)`
  background: ${ThemeProps.color.darkBlue};
  border-radius: 6px 6px 0px 0px;
  display: table-header-group;
`;
const PaymentStatus = styled.div`
  border-radius: 6px;
  width:15px;
  height:15px;
  margin: auto;
`;
const CompletedPayment = styled(PaymentStatus)`
  background: ${ThemeProps.color.gabaGreen};
`;
const PendingPayment = styled(PaymentStatus)`
  background: ${ThemeProps.color.gabaYellow};
`;
const ErrorPayment = styled(PaymentStatus)`
  background: red;
`;
const Item = styled.div`
  display: table-cell;
`;
const ItemContent = styled.div`
  background: ${ThemeProps.color.softPurple};
  color: ${ThemeProps.color.darkBlue};
  border-radius: 6px;
  padding: 6px 10px;
  margin: 2px auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow:ellipsis;
  max-width:100px;
  min-width:50px;
  text-align:center;
`;
const ItemHeader = styled(Item)`
  color: ${ThemeProps.color.white};
  font-weight: bold;
  padding: 6px 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow:ellipsis;
  width:100px;
  text-align:center;
`;


